const material_conditions = [
  {id: 1, text: 'New', comment_required: false},
  {id: 2, text: 'Used', comment_required: false},
  {id: 3, text: 'Scrape', comment_required: true},
  {id: 4, text: 'Faulty', comment_required: true},
];

const packing_statuses = [
  {id: 1, text: 'Packed', comment_required: false},
  {id: 2, text: 'UnPacked', comment_required: true},
];

const transaction_types = [
  {id: 1, text: 'New Released From W/h', in: true, out: false},
  {id: 2, text: 'New Released From W/h but Returned back from site', in: true, out: false},
  {id: 3, text: 'Dismantle Returned From Site', in: true, out: true},
  {id: 4, text: 'Dismantle Returned back From RN Plan', in: true, out: true},
  {id: 5, text: 'test_validation_errors', in: true, out: true},
];


const id = {
  material_conditions: (material_conditions[material_conditions.length -1] || {id: 0}).id,
  packing_statuses: (packing_statuses[packing_statuses.length -1] || {id: 0}).id,
  transaction_types: (transaction_types[transaction_types.length -1] || {id: 0}).id,
};

const new_id = (table) => ++id[table];

export default {
  material_conditions,
  packing_statuses,
  transaction_types,
  id,
  new_id,
}
